// Mobile nav toggle
document.addEventListener('click', function (e) {
  if (e.target.closest('.nav-toggle')) {
    document.querySelector('.nav').classList.toggle('open');
  }
  // FAQ accordion
  const q = e.target.closest('.faq-q');
  if (q) {
    q.parentElement.classList.toggle('open');
  }
});


// Mark active nav link based on current page filename
(function(){
  var path = location.pathname.split('/').pop() || 'index.html';
  document.querySelectorAll('.nav-menu > li > a').forEach(function(a){
    var href = a.getAttribute('href');
    if (href === path) a.classList.add('active');
  });
})();


// Scroll reveal (fade-up) for sections, like Elementor entrance animations
document.addEventListener('DOMContentLoaded', function(){
  var els = document.querySelectorAll('.section .container > *, .section, .cards-banner');
  // target section inner blocks
  var targets = document.querySelectorAll('section.section');
  if(!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold: 0.12});
  targets.forEach(function(t){ t.classList.add('reveal'); io.observe(t); });
});
